module.exports = __webpack_public_path__ + "static/media/Ecommerce2.ce717e72.png";